export enum EntityType {
    ARCHIVE,
    AUDIT_CAMPAIGN,
    AUDIT_RECORD,
    CONDITION_REPORT,
    MEDIA,
    WEMI,
    SPECIMEN
}